import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useTPList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/shipping-providers`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useTPList;
